"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SteppedProgressBar = SteppedProgressBar;
const jsx_runtime_1 = require("react/jsx-runtime");
const utilities_1 = require("@kalkulacka-one/design-system/utilities");
const class_variance_authority_1 = require("class-variance-authority");
const stepProgressVariants = (0, class_variance_authority_1.cva)("", {
    variants: {
        status: {
            inFavour: "ko:bg-primary",
            against: "ko:bg-secondary",
            isNull: "ko:bg-neutral-inactive",
        },
        height: {
            active: "ko:h-2 ko:bg-neutral-active!",
            inactive: "ko:h-1",
        },
    },
    defaultVariants: {
        status: "isNull",
        height: "inactive",
    },
});
function checkAnswer(status) {
    switch (status) {
        case true:
            return "inFavour";
        case false:
            return "against";
        case null:
        case undefined:
            return "isNull";
    }
}
function SteppedProgressBar({ stepItems, stepCurrent, stepTotal, idKey, statusKey }) {
    if (!stepItems || stepItems.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { role: "progressbar", "aria-valuetext": `Question ${stepCurrent} of ${stepTotal}`, "aria-valuenow": stepCurrent, "aria-valuemin": 1, "aria-valuemax": stepTotal, className: "ko:flex ko:items-center ko:justify-start", children: stepItems.map((step, index) => {
            const id = step[idKey];
            const status = step[statusKey];
            return ((0, jsx_runtime_1.jsx)("div", { "aria-hidden": "true", style: {
                    flex: `1 1 calc(100% / ${stepTotal})`,
                    width: `calc(100% / ${stepTotal})`,
                }, className: (0, utilities_1.twMerge)(stepProgressVariants({
                    status: checkAnswer(status),
                    height: stepCurrent === index + 1 ? "active" : "inactive",
                })) }, `bar-${id}`));
        }) }));
}
